module.exports = __webpack_public_path__ + "img/chart-histogram.5dba7dd2.svg";